import $ from 'jquery';
import React, {
    Fragment, useContext, useEffect, useState,
} from 'react';
import DraftEditorStateContextProvider from '../../context/DraftEditorStateContext';
import { PageContext } from '../../context/PageContext';
import { PageStateContext } from '../../context/PageStateContext';

import DraftNotification from './DraftNotification';
import DraftHeader from './DraftHeader';
import DraftTitle from './DraftTitle';
import DraftBody from './DraftBody';
import DraftTOC from './DraftTOC';
import EditLockWrapper from './EditLockWrapper';
import NewDraftRevisionModal from './NewDraftRevisionModal';
import DraftPageUpdateSuggestion from './DraftPageUpdateSuggestion';
import DraftQuestion from './DraftQuestion';
import LoadingDraft from './LoadingDraft';

import { trackPageAnalytics } from '../../utilities/analyticsUtilities';
import { EVENTS } from '../../utilities/CONSTANTS';
import { draftToEditorState, pageToEditorState } from '../../tettra-editor/utilities/contentToEditorState';
import createEmptyEditorState from '../../tettra-editor/utilities/createEmptyEditorState';

import {
    getApiCreateDraftUrl,
    getApiCreateDraftUrlWithQuestionId,
    getApiCreateDraftUrlWithDuplicatePageId,
    getApiCreateDraftUrlWithSuggestionId,
    getApiCreateTemplateDraftUrl,
    getApiCreateDraftUrlWithSuggestionIdAndTemplateId,
    getApiCreateDraftUrlWithPageId,
    getApiCreateSuggestEditDraftwithPageId,
    getApiCreateDraftUrlWithPageIdAndSuggestionId,
    getApiCreateDraftUrlWithTemplateId,
    getApiCreateDraftUrlWithTemplatePageId,
    getApiDraftUrl,
    getApiDraftUrlWithSuggestionId,
    getEditDraftUrl,
} from '../../utilities/urlHelper';

import getParamsFromSearchURL from '../../utilities/getParamsFromSearchURL';

const READ_ONLY_FALSE = false;

const NEW_DRAFT = { title: '', user_id: window.userId };

const setNewDraftCategoryAndFolder = ({ categoryId, folderId }) => {
    if (categoryId) {
        window._tettraDraft.category_id = categoryId;
    }
    if (folderId) {
        window._tettraDraft.folder_id = folderId;
    }
};

const DraftContainer = (props) => {
    const [editorState, setEditorState] = useState();
    const { page } = useContext(PageContext);
    const { pageState, setPageState } = useContext(PageStateContext);
    const {
        path, location: { state, search }, draftId: routeDraftId, isNewDraft,
    } = props;
    const params = getParamsFromSearchURL(search);
    const {
        pageId: duplicatePageIdParam,
        suggestionId: suggestionIdParam,
        questionId: questionIdParam,
        templateId: templateIdParam,
        template: isTemplateParam,
        templatePageId: templatePageIdParam,
        suggestEdit: suggestEditParam,
    } = params || {};
    const { suggestion: stateSuggestion } = state || {};
    const { title: initialTitle, id: page_id, revision_id: activePageRevisionId } = page || NEW_DRAFT;
    const [title, setTitle] = useState(initialTitle);
    window._tettraDraft = window._tettraDraft || {};

    useEffect(() => {
        const url = ((routeDraftId, duplicatePageIdParam, suggestionIdParam, questionIdParam, templateIdParam, templatePageIdParam, page_id, stateSuggestion, suggestEditParam) => {
            if (routeDraftId) {
                if (suggestionIdParam) {
                    return getApiDraftUrlWithSuggestionId(routeDraftId, suggestionIdParam);
                }
                return getApiDraftUrl(routeDraftId);
            } if (page_id && stateSuggestion) {
                return getApiCreateDraftUrlWithPageIdAndSuggestionId(page_id, stateSuggestion.id);
            } if (page_id && suggestEditParam) {
                return getApiCreateSuggestEditDraftwithPageId(page_id);
            } if (page_id) {
                return getApiCreateDraftUrlWithPageId(page_id);
            } if (duplicatePageIdParam) {
                return getApiCreateDraftUrlWithDuplicatePageId(duplicatePageIdParam);
            } if (suggestionIdParam && templateIdParam) {
                return getApiCreateDraftUrlWithSuggestionIdAndTemplateId(suggestionIdParam, templateIdParam);
            } if (questionIdParam) {
                return getApiCreateDraftUrlWithQuestionId(questionIdParam);
            } if (suggestionIdParam) {
                return getApiCreateDraftUrlWithSuggestionId(suggestionIdParam);
            } if (templateIdParam) {
                return getApiCreateDraftUrlWithTemplateId(templateIdParam);
            } if (templatePageIdParam) {
                return getApiCreateDraftUrlWithTemplatePageId(templatePageIdParam);
            } if (isTemplateParam) {
                return getApiCreateTemplateDraftUrl();
            }
            return getApiCreateDraftUrl();

        })(routeDraftId, duplicatePageIdParam, suggestionIdParam, questionIdParam, templateIdParam, templatePageIdParam, page_id, stateSuggestion, suggestEditParam);

        $.get(url)
            .then(({
                success, draft, existingDraft, draftRevisionId, suggestion: draftSuggestion, question: draftQuestion,
            }) => {

                const hasNewRevision = activePageRevisionId && draftRevisionId && activePageRevisionId !== draftRevisionId;
                window.draftId = draft.id;
                window.pageId = draft.page_id;
                window._tettraDraft = { ...window._tettraDraft, ...draft };
                const isTemplateDraft = draft.is_template;
                const isSuggestEdit = draft.is_suggest_edit;
                setPageState({
                    ...pageState, draft, existingDraft, isNewDraft, isTemplateDraft, isSuggestEdit, hasNewRevision, draftSuggestion, draftQuestion,
                });
                if (!routeDraftId) {
                    window.history.replaceState({}, '', getEditDraftUrl(draft.id));
                }
                window.dispatchEvent(new Event(EVENTS.NEW_PAGE_LOADED));
                trackPageAnalytics(draft.title, 'initialLoad', 'Draft');
            }).catch(console.error);

        return () => {
            // Clean up
            window.dispatchEvent(new Event(EVENTS.DISABLE_AUTO_SAVE));
            window.draftId = null;
            window.pageId = null;
            setPageState(null);
            setTitle(null);
            setEditorState(null);
        };
    }, [props.path]);

    useEffect(() => {
        if (routeDraftId && pageState && pageState.draft && !editorState) {
            setEditorState(draftToEditorState(pageState.draft));
            setTitle(pageState.draft.title);
        } else if (pageState && pageState.template) {
            setEditorState(pageToEditorState(pageState.template, READ_ONLY_FALSE));
            setTitle(pageState.template.title);
        } else if (isNewDraft && duplicatePageIdParam && pageState && pageState.draft && !editorState) {
            setEditorState(draftToEditorState(pageState.draft));
            setTitle(pageState.draft.title);
        } else if (isNewDraft && (templateIdParam || templatePageIdParam) && pageState && pageState.draft && !editorState) {
            setEditorState(draftToEditorState(pageState.draft));
            setTitle(pageState.draft.title);
        } else if (isNewDraft && suggestionIdParam && pageState && pageState.draft && !editorState) {
            if (pageState.draft.editor_state) {
                setEditorState(draftToEditorState(pageState.draft));
            } else {
                setEditorState(createEmptyEditorState());
            }
            setTitle(pageState.draft.title);
        } else if (isNewDraft && !duplicatePageIdParam && !suggestionIdParam && !templateIdParam && !templatePageIdParam && !editorState) {
            setEditorState(createEmptyEditorState());
            setNewDraftCategoryAndFolder(params);
        } else if (page && !editorState && !routeDraftId) {
            setEditorState(pageToEditorState(page, READ_ONLY_FALSE));
        } else if (page && pageState && pageState.hasNewRevision) {
            setEditorState(draftToEditorState(pageState.draft));
            setTitle(pageState.draft.title);
        }
    }, [pageState]);

    if (!editorState) {
        return <LoadingDraft title={title} />;
    }

    const suggestion = stateSuggestion || (pageState && pageState.draftSuggestion);
    const draftQuestion = pageState && pageState.draftQuestion;

    return (
        <DraftEditorStateContextProvider>
            <DraftNotification />
            <DraftHeader isSuggestEdit={pageState && pageState.isSuggestEdit} />
            <div className="flex overflow-hidden">
                <div className="page-toc-container">
                    {suggestion && <DraftPageUpdateSuggestion suggestion={suggestion} />}
                    {draftQuestion && <DraftQuestion question={draftQuestion} />}
                    <DraftTOC title={title} />
                </div>
                <div className="page-content-container" style={{ paddingLeft: '44px' }}>
                    <div className="page-middle-width relative" id="page-top">
                        <DraftTitle title={title} setTitle={setTitle} isTemplateDraft={pageState && pageState.isTemplateDraft} />

                        <DraftBody editorState={editorState} />
                    </div>
                </div>
            </div>
            {pageState && pageState.existingDraft && <EditLockWrapper existingDraft={pageState.existingDraft} />}
            {pageState && pageState.hasNewRevision && <NewDraftRevisionModal title={title} />}
        </DraftEditorStateContextProvider>
    );
};

export default DraftContainer;
